import React from 'react';

export const BlankCard: React.FC<{ wrapContent?: boolean, children?: any , className?:string}> = ({ wrapContent, children, className}) => {
  return (
    <div className={`p-4 ${(wrapContent === undefined || !wrapContent) ? 'h-full':''} flex flex-col bg-white ${className} shadow-md rounded-xl`}>
      {children}
    </div>
  );
}